import React from "react";
import { Link } from "react-router-dom";
import VersionCheckButton from "@/components/VersionCheckButton";
import { WEBSITE_DETAILS } from "@/config";
import { FOOTER_LINKS } from "@/data/linksData";

const BottomFooter = ({ version, className }) => {
  return (
    <footer
      className={`mt-8 border-t border-gray-800 pt-8 text-center text-gray-400 ${className ?? ""
        }`}
    >
      <p>
        &copy; {WEBSITE_DETAILS.full_year} {WEBSITE_DETAILS.name}{""}
        <VersionCheckButton>v{version}</VersionCheckButton>. All rights
        reserved.
      </p>
      <nav className="mt-2 flex flex-wrap justify-center gap-x-4 gap-y-2">
        {FOOTER_LINKS.map(({ to, label }) => (
          <div key={label} className="flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-gray-500" />
            <Link
              to={to}
              className="hover:text-white hover:underline text-trim-both"
            >
              {label}
            </Link>
          </div>
        ))}
      </nav>
    </footer>
  );
};

export default BottomFooter;
